import { Component, OnInit, Input, Output, EventEmitter, ApplicationRef, Injector, ComponentFactoryResolver } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SwViewFileComponent } from '../../sw-view-file/sw-view-file.component';
import { SwPhotoAlbumService } from '../../sw-photo-album/sw-photo-album.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { SwViewFileService } from 'src/app/librarys/serves/public/sw-view-file.service';
import { GetSuffixImgService } from 'src/app/librarys/serves/public/get-suffix-img.service'
@Component({
  selector: 'sw-check-attachment-box',
  templateUrl: './sw-check-attachment-box.component.html',
  styleUrls: ['./sw-check-attachment-box.component.css']
})
export class SwCheckAttachmentBoxComponent implements OnInit {

  constructor(
    private injector: Injector,
    private applicationRef: ApplicationRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    public popup: SwPhotoAlbumService ,
    private box:SwMassageBoxService,
    private view :SwViewFileService,  
    private getSuffixImgService : GetSuffixImgService,
     ) { }

  ngOnInit() {
  }

  /**
   * 动态创建磁组件的输入属性，文件信息数组
   */
  @Input() attachmentList:any=[]

  /**
   * 动态创建磁组件的输出属性，用来触发回调
   */
  @Output()  callback = new EventEmitter()

  /**
   * @ignore
   * 文件信息列表
   */
  feilsList:any = []

  /**
   * @ignore
   * 上传请求的根路径
   */
  autoUrl :string = environment.fileWebAPI
  
  /**
   * @ignore
   * 文件信息列表
   */
  showList:any=[]

  /**
   * @ignore
   * 节流阀,避免短时间重复点击
   */
  flag: boolean = true  

  ngOnChanges(): void {
  }

  ngAfterViewInit(): void {
    if(this.attachmentList.length>0){
      this.attachmentList.forEach(ele => {
        let srcType = this.getSuffixImgService.getFileTypeImg(ele.fileSuffix)
        if(srcType == 'assets/Images/files/img.png'){
          //如果是图片类型，就使用原图
          ele.fileSuffixImg = environment.staticFileUrl+ele.filePath+ele.fileName;
        } else {
          ele.fileSuffixImg = srcType;
        }
        ele.fileSuffixPath =environment.staticFileUrl+ele.filePath+this.fileSuffixConversion(ele.fileName);
      });
      setTimeout(()=>{
        this.feilsList = this.attachmentList;
      },100)
    }
  }

/**
 * @ignore
 * 文件预览
 */ 
viewClick(item){
  //调用文件预览服务
  this.view.viewFile(environment.staticFileUrl+item.filePath+item.fileName,item.serverPath+item.filePath+item.fileName,item,this.feilsList)
}

/**
 * @ignore
 * 将Word和Excel转化为PDF后缀才能预览
 */
fileSuffixConversion(fileName){
  let fileSuffix = fileName.split('.');
  switch(fileSuffix[fileSuffix.length-1].toLocaleLowerCase()){
    case "docx" : fileSuffix[fileSuffix.length-1] = "pdf";  break;
    case "doc"  : fileSuffix[fileSuffix.length-1] = "pdf"; break;
    case "xls"  : fileSuffix[fileSuffix.length-1] = "html";break;
    case "xlsx" : fileSuffix[fileSuffix.length-1] = "html";  break;
  }
  return fileSuffix[0]+"."+ fileSuffix[1];
}

  /**
   * @ignore
   * downloadFile() 点击已经上传的文件的下载按钮,将文件下载到本地
   */ 
  downloadFile(item){
    window.location.href = this.autoUrl + "fileDownload/download?fileId="+item.fileInfoId;
  }
}
